import Vue from 'vue';
import YhcSvgIcon from './YhcSvgIcon'; // svg component

// register globally
Vue.component('YhcSvgIcon', YhcSvgIcon);

const req = require.context('../../../assets/svg', false, /\.svg$/);

const requireAll = (requireContext) => requireContext.keys().map(requireContext);
requireAll(req);
